import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index"
import memu from "../store/modules/memu";

//国内页面
const Login = () => import(/* webpackChunkName: "china" */ "../components/Logo/Login");
const IdCard = () => import(/* webpackChunkName: "china" */ "../components/IdCard/IdCard")
const UserInfoPage = () => import(/* webpackChunkName: "china" */ "../components/UserInfoPage/UserInfoPage")
const Question = () => import(/* webpackChunkName: "china" */ "../components/Question/Question")
const ResultState = () => import(/* webpackChunkName: "china" */ "../components/ResultState/ResultState")

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/idCard',
    name: 'idCard',
    component: IdCard
  },
  {
    path: '/userInfoPage',
    name: 'userInfoPage',
    component: UserInfoPage
  },
  {
    path: '/question',
    name: 'question',
    component: Question
  },
  {
    path: '/resultState',
    name: 'resultState',
    component: ResultState
  }
];

const router = new VueRouter({
  //返回 savedPosition，在按下 后退/前进 按钮时，就会像浏览器的原生表现那样：
  scrollBehavior(to,from,savePosition){
    // console.log(to,from,savePosition)
    if(savePosition){
      return savePosition
    }else{
      return{
        x: 0,
        y: 0
      }
    }
  },
  routes
});

router.beforeEach((to,from,next)=>{
  let phone = store.state.memu.fphone
  let email = store.state.memu.userEmail
  if((!email && !phone) && to.name !== 'login'){
    next({path: '/login'})
  }else{
    next()
  }
})

export default router;
